import type { Rule } from 'ant-design-vue/es/form'
import $t from '@/lang/dc-I18n'
// 联系格式五选一 必填
export const contactValidate = async (rule: any, value: string, from: any, formRef: any, isB2B = false) => {
  const { mobile, email, wechat, qq, tel } = from
  if (isB2B) {
    if (rule.field.includes('mobile') && !mobile) {
      return Promise.reject(new Error('请输入手机号'))
    }

    if (rule.field.includes('wechat') && !wechat) {
      return Promise.reject(new Error('请输入微信'))
    }

    return Promise.resolve()
  } else if (!isB2B && !mobile && !email && !wechat && !qq && !tel) {
    return Promise.reject(new Error('请输入，联系方式必填其一'))
  } else {
    // 清空其他的校验
    const allNamePath: any = ['mobile', 'email', 'wechat', 'qq', 'tel'].filter(
      (item) => !rule.field.includes(item) && !from[item]
    )
    if (formRef) {
      const namePath: any = rule.field.split('.')
      if (namePath.length === 1) {
        formRef.clearValidate(allNamePath)
      } else if (namePath.length > 1) {
        namePath.splice(namePath.length - 1, 1)
        const finallPath = allNamePath.reduce((prev: any, curr: string) => {
          return [...prev, [...namePath, curr]]
        }, [])
        formRef.clearValidate(finallPath)
      }
    }
    // 校验手机号
    if (value) {
      const ruleObj: any = {
        mobile: {
          reg: /^$|^(\+|-|[0-9]){7,20}$/,
          message: '手机号格式不正确'
        },
        email: {
          reg: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // reg: /^$|^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/,
          message: '邮箱格式不正确'
        },
        wechat: {
          reg: /^$|^.{3,30}$/,
          message: '微信格式不正确'
        },
        qq: {
          reg: /^$|^[1-9]{1}[0-9]{2,30}$/,
          message: 'qq格式不正确'
        },
        tel: {
          reg: /^$|^(\+|-|[0-9]){5,20}$/,
          message: '固定电话格式不正确'
        }
      }
      let lastFile = rule.field.split('.')
      lastFile = lastFile[lastFile.length - 1]
      if (ruleObj[lastFile]) {
        if (value && !ruleObj[lastFile].reg.test(value)) {
          return Promise.reject(new Error(ruleObj[lastFile].message))
        } else {
          return Promise.resolve()
        }
      }
    }
  }
}
// ofbu联系格式五选一 必填
export const ofbuContactValidate = async (rule: any, value: string, from: any, formRef: any) => {
  const { mobile, email, skype } = from
  if (!mobile && !email && !skype) {
    return Promise.reject(new Error($t('tips.AJpVtAl4')))
  } else {
    // 清空其他的校验
    const allNamePath: any = ['mobile', 'email', 'skype'].filter((item) => !rule.field.includes(item) && !from[item])
    if (formRef) {
      const namePath: any = rule.field.split('.')
      if (namePath.length === 1) {
        formRef.clearValidate(allNamePath)
      } else if (namePath.length > 1) {
        namePath.splice(namePath.length - 1, 1)
        const finallPath = allNamePath.reduce((prev: any, curr: string) => {
          return [...prev, [...namePath, curr]]
        }, [])
        formRef.clearValidate(finallPath)
      }
    }
    // 校验手机号
    if (value) {
      const ruleObj: any = {
        mobile: {
          reg: /^$|^(\+|-|[0-9]){7,20}$/,
          message: $t('tips.W28os2L')
        },
        email: {
          reg: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // reg: /^$|^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/,
          message: $t('tips.SQvb1u')
        }
        // skype: {
        //   max: 50,
        //   min: 1,
        //   message: 'skype格式不正确'
        // }
      }
      let lastFile = rule.field.split('.')
      lastFile = lastFile[lastFile.length - 1]
      if (lastFile === 'skype') {
        if (value.length > 50) {
          return Promise.reject(new Error($t('tips.SiIDpG2')))
        }
      }
      if (ruleObj[lastFile]) {
        if (value && !ruleObj[lastFile].reg.test(value)) {
          return Promise.reject(new Error(ruleObj[lastFile].message))
        } else {
          return Promise.resolve()
        }
      }
    }
  }
}
// 联系人姓名
export const concatNameValidate = async (rule: Rule, value: string) => {
  const myreg = /^([\u4E00-\u9FA5A-Za-z0-9.\s]){1,50}$/
  if (value) {
    if (value.length > 50) {
      return Promise.reject(new Error($t('tips.SiIDpG1')))
    }
    if (!myreg.test(value)) {
      return Promise.reject(new Error($t('tips.HcXrhVV')))
    }
  }
  return Promise.resolve()
}
// 手机号
export const mobileValidate = async (rule: Rule, value: string) => {
  const myreg = /^$|^(\+|-|[0-9]){7,20}$/
  if (value && !myreg.test(value)) {
    return Promise.reject(new Error($t('tips.W28os2L')))
  } else {
    return Promise.resolve()
  }
}
// 邮箱
export const emailValidate = async (rule: Rule, value: string) => {
  const myreg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
  if (value && !myreg.test(value)) {
    return Promise.reject(new Error($t('tips.SQvb1u')))
  } else {
    return Promise.resolve()
  }
}

// 大于或等于0，最多两位小数
export const twoDecimalValidate = async (rule: Rule, value: string) => {
  const myreg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/
  if (value && !myreg.test(value)) {
    return Promise.reject(new Error('支持大于或等于0,仅保留最多两位小数'))
  } else {
    return Promise.resolve()
  }
}

// 单选框校验(值为数字类型)
export const selectForNumberValidate = async (rule: any, value: number | string, ...arg: any) => {
  if (!rule.required) {
    return Promise.resolve()
  }
  const lastArg = arg[arg.length - 1]
  const defaultVal = -9
  if (value == null || value === '' || value === defaultVal || value === rule.filterVal) {
    return Promise.reject(typeof lastArg === 'string' ? lastArg : '请选择')
  } else {
    return Promise.resolve()
  }
}
// 地图校验
export const mapValidate = async (rule: any, value: any, ...arg: any) => {
  if (!rule.required) {
    return Promise.resolve()
  }
  const lastArg = arg[arg.length - 1]
  if (!value || !value.longitude || !value.latitude || value.longitude * 1 === -9 || value.latitude * 1 === -9) {
    return Promise.reject(typeof lastArg === 'string' ? lastArg : '请选择')
  } else {
    return Promise.resolve()
  }
}
// 联动必填校验
export const arrayValueValidate = async (rule: any, value: any, valObj: any) => {
  // 如果其中有一项有值，则必填
  const keys: any[] = []
  let hasVal = false
  Object.keys(valObj).forEach((key: any) => {
    keys.push(key)
    if (valObj[key] != null && valObj[key] !== '' && valObj[key] !== -9) {
      hasVal = true
    }
  })
  if (hasVal) {
    if (!value || value === -9) {
      return Promise.reject(new Error(rule.message))
    }
  }
  // else {
  //   let namePath: any = rule.field.split('.')
  //   namePath.splice(namePath.length - 1, 1)
  //   namePath = namePath.map((k: any) => {
  //     if (k && Number(k)) {
  //       k = Number(k)
  //     }
  //     return k
  //   })
  //   const finallPath = keys.reduce((prev: any, curr: string) => {
  //     return [...prev, [...namePath, curr]]
  //   }, [])
  //   formRef.clearValidate(finallPath)
  // }
  return Promise.resolve()
}
